import React from "react";

function CubeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3080_1533)">
        <path
          d="M16.1999 5.73168C16.1996 5.455 16.1266 5.18326 15.9881 4.94371C15.8496 4.70417 15.6506 4.50525 15.411 4.36691L9.88883 1.21138C9.64898 1.0729 9.3769 1 9.09995 1C8.82299 1 8.55091 1.0729 8.31106 1.21138L2.78888 4.36691C2.54927 4.50525 2.35025 4.70417 2.21178 4.94371C2.07332 5.18326 2.00028 5.455 2 5.73168V12.0427C2.00028 12.3194 2.07332 12.5912 2.21178 12.8307C2.35025 13.0702 2.54927 13.2692 2.78888 13.4075L8.31106 16.563C8.55091 16.7015 8.82299 16.7744 9.09995 16.7744C9.3769 16.7744 9.64898 16.7015 9.88883 16.563L15.411 13.4075C15.6506 13.2692 15.8496 13.0702 15.9881 12.8307C16.1266 12.5912 16.1996 12.3194 16.1999 12.0427V5.73168Z"
          stroke="#667085"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.23682 4.94336L9.1001 8.88777M9.1001 8.88777L15.9634 4.94336M9.1001 8.88777V16.7766"
          stroke="#667085"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3080_1533">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CubeIcon;
